// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChapterIcon_icon__biGgy"};